// 상품/견적항목의 "세부사양"을 {title, content} 리스트로 표현.
// detail_sections 컬럼이 비어있으면 레거시 4개 필드(main_title / sub_description / sw_name / features)에서 derive.

export function deriveDetailSections(row) {
  if (!row) return [];
  if (Array.isArray(row.detail_sections) && row.detail_sections.length > 0) return row.detail_sections;
  const out = [];
  if (row.main_title)      out.push({ title: row.main_title, content: '' });
  if (row.sub_description) out.push({ title: '', content: row.sub_description });
  if (row.sw_name)         out.push({ title: 'S/W명', content: row.sw_name });
  if (Array.isArray(row.features) && row.features.length > 0) {
    out.push({ title: '기능', content: row.features.map(f => `· ${f}`).join('\n') });
  }
  return out;
}
